import { render } from "./Chefs.vue?vue&type=template&id=5a5020cb"
import script from "./Chefs.vue?vue&type=script&lang=js"
export * from "./Chefs.vue?vue&type=script&lang=js"

import "./Chefs.vue?vue&type=style&index=0&id=5a5020cb&lang=scss"
script.render = render

export default script